import React, { Component } from 'react';
import styled from "styled-components";
import TitleWithContent from '../common/TitleWithContent';
import { Link } from "react-router-dom";
import SolarOnImg from "../../../assets/images/ems/solar-panel-on.png";
import SolarOffImg from "../../../assets/images/ems/solar-panel_off.png";
import DeviceOnImg from "../../../assets/images/ems/device_on.png";
import DeviceOffImg from "../../../assets/images/ems/device_off.png";
import BatteryOnImg from "../../../assets/images/ems/blue-battery_on.png";
import BatteryOffImg from "../../../assets/images/ems/blue-battery_off.png";
import ArrowDown from "../../../assets/images/ems/arrow-down.png";
import ArrowUpDown from "../../../assets/images/ems/arrow-up-down.png";
import { BoxWrapper } from '../common/style';
// import PS from '../../PlantList/MonitoringApiService';
import CS from '../../../commons/services/Common';
import { ROUTES } from '../../../commons/constants/routes/routes';
import { withTranslation } from 'react-i18next';
import { PowerSystemInfoCardColumnWidth } from './translationUiConst';
import AutoFitText from '../../../commons/components/text/AutoFitText';

// ----------------------S: powerSystem ---------------------- //
class PowerSystem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectId: this.props.projectId,
      plantList: [],
      inverterList: [],
      deviceList: [],
      batteryList: [],
      systemInfo: {
        plant: {
          pvUsedPower: 0,
          supplyRate: 0,
        },
        carrier: {
          pwCons: 0,
          dayPwCons: 0,
        },
        battery: {
          operationRate: 0,
          capcity: 0,
          charging: {
            time: 0,
            voltage: 0,
            ampere: 0,
          },
          discharging: {
            time: 0,
            voltage: 0,
            ampere: 0,
          }
        },
      }
    }
  }
  componentDidUpdate(prevProps) {
    // if (!this.batteryDataInitialized && 
    //     prevProps.batteryList?.length > 0 && 
    //     prevProps.batteryCapacity !== 0 ) {
    if (prevProps.emsBatterySum !== this.props.emsBatterySum) {
      this.setBatteryData();
      this.batteryDataInitialized = true;
    }
  }

  async setBatteryData() {
    const { 
      emsBatteryData, 
      batteryCapacity,
      batteryChargeVoltage,
      batteryDischargeVoltage,
      batteryChargeAmpere,
      batteryDischargeAmpere,
      emsBatterySum
    } = this.props;
    
    const dayCharge = CS.sumValuesAtPath(emsBatterySum, 'day_ed1_charge_wattage');
    const dayDischarge = CS.sumValuesAtPath(emsBatterySum, 'day_ed2_discharge_wattage');
    const dayChargeTime = this.calcTimeAndFormat(dayCharge, batteryCapacity);
    const dayDischargeTime = this.calcTimeAndFormat(dayDischarge, batteryCapacity);
    const operationRate = ((Math.abs(dayCharge / batteryCapacity) + Math.abs(dayDischarge / batteryCapacity)) / 24 * 100).toFixed(0);
    this.setState({
      systemInfo: {
        ...this.state.systemInfo,
        battery: {
          ...this.state.systemInfo.battery,
          operationRate,
          charging: {
            time: dayChargeTime,
            voltage: batteryChargeVoltage,
            ampere: batteryChargeAmpere,
          },
          discharging: {
            time: dayDischargeTime,
            voltage: batteryDischargeVoltage,
            ampere: batteryDischargeAmpere,
          }
        }
      }
    });
  }

  calcSolarSupplyRate(pvCons, totalCons) {
    if (totalCons === 0) return 0;
    return pvCons / totalCons * 100;
  }

  calcTimeAndFormat(kWh, capacityKw) {
    if (capacityKw === 0) return "0h 0m";
    if (kWh === 0) return "0h 0m";

    const time = kWh / capacityKw;
    const hour = Math.floor(time);
    const minute = Math.floor((time - hour) * 60);
    return `${hour}h ${minute}m`;
  }
  calcTime(kWh, capacityKw) {
    if (capacityKw === 0) return 0;
    if (kWh === 0) return 0;

    const time = kWh / capacityKw;
    return time;
  }
  render() {
    const { projectId, plantList, deviceList, batteryList, emsInvSum, emsBatteryData, emsCarrierSum = {}, emsBatterySum = {}, todayPower, t, i18n } = this.props;
    const { systemInfo } = this.state;
    const {
      battery: {
        operationRate,
        charging: {
          time: chargeTime,
          voltage: chargeVoltage,
          ampere: chargeAmpere
        },
        discharging: {
          time: dischargeTime,
          voltage: dischargeVoltage,
          ampere: dischargeAmpere
        }
      }
    } = systemInfo;
    console.log("discharging voltage", dischargeVoltage);
    const {
      power: solarPower = 0,
    } = emsInvSum.reduce((acc, curr) => {
      acc.power += curr.power;
      return acc;
    }, { power: 0 });
    const {
      day_total_cons_power: dayPwCons = 0,
      power: pwCons = 0,
    } = emsCarrierSum.reduce((acc, curr) => {
      acc.day_total_cons_power += curr.day_total_cons_power;
      acc.power += curr.power;
      return acc;
    }, { day_total_cons_power: 0, power: 0 });

    const {
      day_ed2_discharge_wattage: dayDischarge = 0,
    } = emsBatterySum.reduce((acc, curr) => {
      acc.day_ed2_discharge_wattage += curr.day_ed2_discharge_wattage;
      return acc;
    }, { day_ed2_discharge_wattage: 0 });

    const batterySupplyRate = dayDischarge / dayPwCons * 100 || 0;
    const totalDeviceConsuption = CS.sumValuesAtPath(deviceList, 'pwConsumption');
    const carrierDemand = dayPwCons / totalDeviceConsuption * 100 || 0;
    // const pvCons = dayPwCons - dayDischarge;
    const sortedEmsBatteryData = emsBatteryData.sort((a, b) => Number(a._id) - Number(b._id));
    const ess = sortedEmsBatteryData[sortedEmsBatteryData.length - 1]?.hh_ed2_discharge_wattage || 0;
    return (
      <TitleWithContent title={t('key78')}>
        <BoxWrapper height={"325px"}>
          <div className="line" />
          <InfoCardColumn title={t('key83')} value={`${calcPvCons(solarPower, pwCons).toFixed(2)} kW`} className="pv" t={t} i18n={i18n}/>
          <InfoCardColumn title={t('key84')} value={`${ess.toFixed(0)} kW`} className="ess" t={t} i18n={i18n}/>
          <InfoCardColumn title={t('key90')} time={chargeTime} voltage={`${chargeVoltage?.toFixed(1) || 0} V`} current={`${chargeAmpere?.toFixed(1) || 0} A`} className="charging" t={t} i18n={i18n}/>
          <InfoCardColumn title={t('key91')} time={dischargeTime} voltage={`${dischargeVoltage?.toFixed(1) || 0} V`} current={`${dischargeAmpere?.toFixed(1) || 0} A`} className="discharging" t={t} i18n={i18n}/>
          <SolarInfo supply={calcSolarSupplyRate(todayPower, pwCons)} projectId={projectId} plantList={plantList} t={t} i18n={i18n}/>
          <DeviceInfo demand={carrierDemand} projectId={projectId} deviceList={deviceList} t={t} i18n={i18n}/>
          <BatteryInfo supply={batterySupplyRate} operating={operationRate} projectId={projectId} batteryList={batteryList} t={t} i18n={i18n}/>
        </BoxWrapper>
      </TitleWithContent>
    )
  }
}

class SolarInfo extends Component {

  getLink() {
    const { projectId, plantList } = this.props;

    if (plantList.length === 1) return ROUTES.PLANT_LIST(projectId).SOLAR_DETAIL(plantList[0].id);
    if (plantList.length > 1) return `${ROUTES.PLANT_LIST(projectId).MAIN}?tab=0`; // tab=0: 발전소, tab:1: 전력기기, tab:2: 배터리
    return undefined; // 오류일 경우 어떻게 처리할지
  }
  render() {
    const {
      supply = 0,
      plantList,
      t
    } = this.props;
    
    return (
      <DeviceContainer className="solar-info">
        {
          plantList && plantList.length > 0 ? (
            <Link to={this.getLink()}>
              <div className="inner-container">
                <p>{t('key80')}</p>
                  <img src={plantList.length === 0 ? SolarOffImg : SolarOnImg} alt="" className="solar-img"/>
                {/* <InfoCardRow title={t('key85')} value={supply.toFixed(0)} type="wide"/> */}
              </div>
            </Link>
          ) : (
            <div className="inner-container">
              <p>{t('key80')}</p>
                <img src={plantList.length === 0 ? SolarOffImg : SolarOnImg} alt="" className="solar-img"/>
              {/* <InfoCardRow title={t('key85')} value={supply.toFixed(0)} type="wide"/> */}
            </div>
          )
        }
      </DeviceContainer>
    )
  }
}

class DeviceInfo extends Component {
  getLink() {
    const { projectId, deviceList } = this.props;

    // if (deviceList.length === 1) return `/plant-list/power/detail`; // 넘겨야할 location state가 많으므로 임시 생략
    if (deviceList.length >= 1) return `${ROUTES.PLANT_LIST(projectId).MAIN}?tab=1`; // tab=0: 발전소, tab:1: 전력기기, tab:2: 배터리
    return ''; // 오류일 경우 어떻게 처리할지
  }
  render() {
    const { 
      demand = 0,
      deviceList,
      t,
      i18n
    } = this.props;
    return(
      <DeviceContainer className="device-info">
        {
          deviceList && deviceList.length > 0 ? (
            <Link to={this.getLink()}>
              <div className="inner-container">
                <p>{t('key81')}</p>
                <img src={ArrowDown} alt="" className="arrow-img"/>
    
                  <img src={deviceList.length === 0 ? DeviceOffImg : DeviceOnImg} alt="" className="device-img"/>
                {/* <div className="bottom-right">
                  <InfoCardRow title={t('key82')} value={demand.toFixed(0)}/>
                </div> */}
              </div>
            </Link>
          ) : (
            <div className="inner-container">
              <p>{t('key108')}</p>
              <img src={ArrowDown} alt="" className="arrow-img"/>
  
                <img src={deviceList.length === 0 ? DeviceOffImg : DeviceOnImg} alt="" className="device-img"/>
              {/* <div className="bottom-right">
                <InfoCardRow title={t("key526")} value={demand.toFixed(0)}/>
              </div> */}
            </div>
          )
        }
      </DeviceContainer>
    )
  }
}
class BatteryInfo extends Component {

  getLink() {
    const { projectId, batteryList } = this.props;
    const toAlone = {
      pathname: ROUTES.PLANT_LIST(projectId).BATTERY_DETAIL(batteryList[0].id),
      state: {
        projectId,
        battery: batteryList[0],
        batteryList
      }
    }
    if (batteryList.length === 1) return toAlone;
    return `${ROUTES.PLANT_LIST(projectId).MAIN}?tab=2`;
  }

  render() {
    const {
      supply = 0,
      operating = 0,
      batteryList,
      t
    } = this.props;
    return(
      <DeviceContainer className="battery-info">
        {
          batteryList && batteryList.length > 0 ? (
            <Link to={this.getLink()}>
              <div className="inner-container">
                <p>{t('key112')}</p>
                <img src={ArrowUpDown} alt="" className="arrow-img"/>
                <img src={batteryList.length === 0? BatteryOffImg : BatteryOnImg} alt="" className="battery-img"/>
                {/* <div className="bottom-left">
                  <InfoCardRow title={t('key113')} value={typeof operating === "number" ? operating?.toFixed(0) : operating}/>
                </div>
                <div className="bottom-right">
                  <InfoCardRow title={t('key85')} value={supply.toFixed(0)}/>
                </div> */}
              </div>
            </Link>
          ) : (
            <div className="inner-container">
              <p>{t('key82')}</p>
              <img src={ArrowUpDown} alt="" className="arrow-img"/>
              <img src={batteryList.length === 0? BatteryOffImg : BatteryOnImg} alt="" className="battery-img"/>
              {/* <div className="bottom-left">
                <InfoCardRow title={t('key91')} value={ (Number(operating) && Number(operating)?.toFixed(0)) || 0}/>
              </div>
              <div className="bottom-right">
                <InfoCardRow title={t('key85')} value={supply.toFixed(0)}/>
              </div> */}
            </div>
          )
        }
      </DeviceContainer>
    )
  }
}

const DeviceContainer = styled.div`
  position: absolute;

  a {
    text-decoration: none;
    
    &:hover {
      text-decoration: none;
    }
  }
  &.solar-info {
    top: 42px;
    left: 27px;
  }

  &.device-info {
    top: 22px;
    left: 438px;
  }

  &.battery-info {
    top: 163px;
    left: 438px;
  }

  & .inner-container {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: fit-content;
  }
  & .solar-img {
    width: 50px;
    height: 50px;
    margin: 10px 0 16px 0;
  }
  & .battery-img {
    width: 125px;
    height: 35px;
  }
  & .arrow-img {
    width: 12px;
    height: 39px;
    margin: 5px;
  }
  & .device-img {
    width: 125px;
    height: 35px;
  }

  & .bottom-right {
    position: absolute;
    width: fit-content;
    right: 0;
    bottom: 0;
    transform: translate(50%, 50%);
  }
  & .bottom-left {
    position: absolute;
    // width: fit-content;
    width: 130px;
    left: 0;
    bottom: 0;
    transform: translate(-50%, 50%);
  }
  & p {
    font-size: 14px;
    color: #fff;
    background-color: #2f3191;
    width: fit-content;
    min-width: 80px;

    padding: 6px 12px;
    border-radius: 10px;
    text-align: center;
    font-weight: bold;
  }
`;

class InfoCardRow extends Component {
  render() {
    const {
      title,
      value,
      type = "default"
    } = this.props;
    return (
      <InfoCardRowContainer>
        <InfoRowTitle>
            {title}
        </InfoRowTitle>
        <InfoRowContent type={type}>{value}%</InfoRowContent>
      </InfoCardRowContainer>
    )
  }
}
const InfoCardRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid #2F3191;
  border-radius: 6px;
  overflow: hidden;
  width: fit-content;
`;
const InfoRowTitle = styled.div`
  font-size: 12px;
  padding: 5.5px;
  width: fit-content;
  background-color: #D8D9FD;
`;
const InfoRowContent = styled.div`
  font-size: 14px;
  line-height: 24px;
  font-weight: 600;
  text-align: center;
  padding: 0 4px;
  background-color: #fff;
  ${({ type }) => type === "default" ? "" : "width: 68px"};
`;

class InfoCardColumn extends Component {
  render() {
    const {
      title,
      value,
      time,
      voltage,
      current,
      className = "",
      t,
      i18n
    } = this.props;
    return (
      <InfoCardColumnContainer 
        className={className}
        position={PowerSystemInfoCardColumnWidth(i18n).position}
        titleWidth={PowerSystemInfoCardColumnWidth(i18n).titleWidth}
      >
        {
          value ? (
            <dl>
              <dt>{title}</dt>
              <div>
                <dd>{value}</dd>
              </div>
            </dl>
          ) : (
            <dl>
              <dt>{title}</dt>
              <div>
                {/* <dd>
                  <span>time</span>
                  <span>{time}</span>
                </dd> */}
                <dd>
                  <span>{t('key88')}</span>
                  <span>{voltage}</span>
                </dd>
                <dd>
                  <span>{t('key89')}</span>
                  <span>{current}</span>
                </dd>
              </div>
            </dl>
          )
        }
        
      </InfoCardColumnContainer>
    )
  }
}

const InfoCardColumnContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  border: 1px solid #2F3191;
  border-radius: 6px;
  overflow: hidden;
  width: fit-content;
  box-sizing: border-box;
  background-color: #fff;

  &.pv {
    top: 42px;
    ${({ position }) => position ? `left: ${position.pvLeft};` : 'left: 248px;'}
  }
  &.ess {
    top: 42px;
    ${({ position }) => position ? `left: ${position.essLeft};` : 'left: 654px;'}
  }
  &.charging {
    top: 181px;
    ${({ position }) => position ? `left: ${position.chargingLeft};` : 'left: 228px;'}
  }
  &.discharging {
    top: 181px;
    ${({ position }) => position ? `left: ${position.dischargingLeft};` : 'left: 654px;'}
  }
  & div {
    padding 4px 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  & dt {
    font-size: 12px;
    padding: 4px 10px;
    background-color: #D8D9FD;
    text-align: center;
  }
  & dd {
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
  }
  & dd span:first-child {
    position: relative;
    ${({ titleWidth }) => titleWidth ? `width: ${titleWidth};` : 'width: 41px;'}
    text-align: left;
    display: inline-block;

    &::after {
      content: "";
      position: absolute;
      right: 0;
      top: 50%;
      width: 1px;
      height: 10px;
      background-color: #2F3191;
      transform: translateY(-50%);
    }
  }
  & dd span:last-child {
    width: 69px;
    text-align: right;
    display: inline-block;
  }
`;

// ----------------------E: powerSystem ---------------------- //

export default withTranslation()(PowerSystem);

function calcSolarSupplyRate(todayPower, dayCons) {
  if (dayCons === 0) return 0;
  if (todayPower === 0) return 0;

  if (todayPower > dayCons) return 100;
  return todayPower / dayCons * 100;
}

function calcPvCons(todayPower, dayPwCons) {
  if (todayPower === 0) return 0;
  if (dayPwCons === 0) return 0;
  
  if (todayPower > dayPwCons) return dayPwCons;
  if (todayPower < dayPwCons) return todayPower;
  return todayPower;
}